<script setup>
import page from '@/preload/data/imprintPage.json'
import config from '@/preload/data/config.json'

useHead({
  title: `${config.pagetitle} | Impressum`
})
</script>

<template>
  <div v-if="page" :class="page.withoutVerticalSpace ? '' : 'mt-10'">
    <cms-block-renderer :blocks="page.blocks" />
  </div>
</template>
